import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HxAuthService, PermissionKey } from 'hx-services';

/**
 * /report/monitoring and /report/operator-summary are gated on `callcenter_view_report` (same
 * permission the backend enforces on their endpoints) — without it the user is sent back to /call-center.
 */
export const monitoringReportGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const auth = inject(HxAuthService);
  const router = inject(Router);
  const fallback = router.createUrlTree(['/call-center']);
  return auth.getPermissions({ permissions: [PermissionKey.callcenter_view_report] }).pipe(
    map(permissions => permissions.some(p => p.key === PermissionKey.callcenter_view_report) ? true : fallback),
    catchError(() => of(fallback)),
  );
};
